import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import NotificationsIcon from '@mui/icons-material/Notifications';
import COLORS from '../../../theme/Colors';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  alignSelf: 'center',
  cursor: 'pointer',
  zIndex: 1100,
  position: 'relative',
});

export const StyledNotificationIcon = styled(NotificationsIcon)((props) => ({
  color: props.color === 'white' ? COLORS.white : COLORS.black,
  transition: 'all 0.2s ease',
  fontSize: '28px',
  '&:hover,&:focus': {
    color: COLORS.primary,
    transform: 'scale(1.08)',
  },
}));

export const StyledPaper = styled(Paper)({
  boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.03)',
  marginTop: '12px',
  borderRadius: '16px',
  overflow: 'hidden',
  border: '1px solid #F1F5F9',
  '@media (min-width:320px)': {
    width: '320px',
  },
  '@media (min-width:768px)': {
    width: '360px',
  },
});

export const HeaderBox = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '14px 18px',
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #F1F5F9',
});

export const HeaderTitle = styled('span')({
  fontWeight: 700,
  fontSize: '14.5px',
  color: '#0F172A',
  fontFamily: FONTS_FAMILY.bold.body,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const NotificationBadgePill = styled('span')({
  backgroundColor: '#F1F5F9',
  color: COLORS.primary,
  fontSize: '11px',
  fontWeight: 700,
  padding: '2px 8px',
  borderRadius: '999px',
});

export const NotificationContainer = styled('div')(props => ({
  padding: '12px 16px',
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  textAlign: 'left',
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #F8FAFC',
  transition: 'all 0.15s ease-in-out',
  position: 'relative',
  '&:last-child': {
    borderBottom: 'none',
  },
  '&:hover': {
    backgroundColor: '#F8FAFC',
    cursor: 'pointer',
  }
}));

export const IconWrapper = styled('div')({
  width: '34px',
  height: '34px',
  minWidth: '34px',
  borderRadius: '10px',
  backgroundColor: '#F1F5F9',
  color: COLORS.primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ContentBox = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
});

export const NotificationTitle = styled('h4')({
  margin: '0 0 2px 0',
  fontWeight: 600,
  fontFamily: FONTS_FAMILY.bold.body,
  textAlign: 'left',
  fontSize: '13px',
  color: '#0F172A',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const NotificationText = styled('p')({
  margin: '0 0 4px 0',
  textAlign: 'left',
  fontFamily: FONTS_FAMILY.regular.body,
  fontSize: '12px',
  color: '#64748B',
  lineHeight: '1.4',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  '-webkit-box-orient': 'vertical',
});

export const NotificationFooterTag = styled('span')({
  fontSize: '10.5px',
  fontWeight: 600,
  color: COLORS.secondary,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '3px',
});

export const EmptyBox = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '32px 20px',
  textAlign: 'center',
});